import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["locale"];
import React from 'react';
import { Context } from "../../enhances/WithI18n.mjs";
function i18nAppLocaleEnhance() {
  return {
    wrapperProps: function wrapperProps(props) {
      var locale = props.locale,
        other = _objectWithoutProperties(props, _excluded);
      var contextLocale = React.useContext(Context);
      if (!locale && !contextLocale) return props;
      return _objectSpread(_objectSpread({}, other), {}, {
        locale: locale !== null && locale !== void 0 ? locale : contextLocale
      });
    }
  };
}
export default i18nAppLocaleEnhance;
//# sourceMappingURL=i18n.mjs.map